<template>
  <div id="root">
    <div v-if="isMobile" class="mobile-blocked">
      <h2>Akses dari perangkat mobile tidak didukung.</h2>
      <p>Silakan gunakan PC atau laptop untuk mengakses aplikasi ini.</p>
    </div>
    <div v-else :class="cssClasses">
      <component
        :is="$route.meta.layout"
        :title="title"
        :is-x-small="screen.getScreenSizeInfo.isXSmall"
        :is-large="screen.getScreenSizeInfo.isLarge"
      >
        <div class="content">
          <router-view :key="routeKey" />
        </div>
        <template #footer>
          <app-footer />
        </template>
      </component>
    </div>
  </div>
</template>

<script>
import AppFooter from "./components/app-footer";
import { sizes, subscribe, unsubscribe } from "./utils/media-query";
import {
  getCurrentInstance,
  reactive,
  onMounted,
  onBeforeUnmount,
  computed,
  ref,
} from "vue";
import { useRoute } from "vue-router";
import { useAppStore } from "@/stores/UseAppStore";

function getScreenSizeInfo() {
  const screenSizes = sizes();
  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter((cl) => screenSizes[cl]),
  };
}

function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export default {
  components: {
    AppFooter,
  },
  setup() {
    const route = useRoute();
    const appStore = useAppStore();
    const vm = getCurrentInstance();

    const title = vm.proxy.$appInfo.title;

    const isMobile = ref(isMobileDevice());

    const routeKey = computed(() =>
      appStore.needsRemount ? Date.now() : route.fullPath
    );
    if (appStore.needsRemount) {
      appStore.resetRemount();
    }

    const screen = reactive({ getScreenSizeInfo: getScreenSizeInfo() });

    function screenSizeChanged() {
      screen.getScreenSizeInfo = getScreenSizeInfo();
    }

    onMounted(() => {
      subscribe(screenSizeChanged);
    });

    onBeforeUnmount(() => {
      unsubscribe(screenSizeChanged);
    });

    const cssClasses = computed(() => {
      return ["app"].concat(screen.getScreenSizeInfo.cssClasses);
    });

    return {
      title,
      routeKey,
      screen,
      cssClasses,
      isMobile,
    };
  },
};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  min-height: 100%;
  height: 100%;
}

#root {
  height: 100%;
}

* {
  box-sizing: border-box;
}

.app {
  @import "./themes/generated/variables.base.scss";
  background-color: darken($base-bg, 5);
  display: flex;
  height: 100%;
  width: 100%;
}

.mobile-blocked {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 20px;
  background-color: #f8f9fa;
}
</style>
